import React from 'react';
import { Flex, Typography } from 'antd';
import UserTable from './UserTable';

const { Title, Text } = Typography;

const UserManagement: React.FC = () => {
  return (
    <Flex vertical gap={24} style={{ marginTop: 16 }}>
      <Flex vertical gap={8}>
        <Title level={2}>User Management</Title>
        <Text>Manage users for organizations</Text>
      </Flex>
      <UserTable />
    </Flex>
  );
};

export default UserManagement;
